import { render, staticRenderFns } from "./FiveYearSavings.vue?vue&type=template&id=efc4aa8a"
import script from "./FiveYearSavings.vue?vue&type=script&lang=ts"
export * from "./FiveYearSavings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports